import { Typography } from 'antd';
import withCustomComponent from 'shared/helpers/withCustomComponent';
import TitleStyled from './Title.style';

const Title = withCustomComponent(Typography.Title, TitleStyled);

export default Title;
